// extracted by mini-css-extract-plugin
export default {"tooltip":"czLC2dOo4PtaB-ffYkvfCw=="};